import { useDispatch, useSelector } from 'react-redux';

import {
  getBadges,
  setBadgesAction,
  clearBadgesAction,
  setStudentBadgesAction,
  clearStudentBadgesAction,
} from './redux/slice';

import { UseBadgesState, BadgesApiResponse, StudentBadgesApiResponse } from './types';

const useMenu = (): UseBadgesState => {
  const dispatch = useDispatch();

  const { badges, studentBadges } = useSelector(getBadges);

  const setBadges = (receivedBadges: BadgesApiResponse) => {
    dispatch(setBadgesAction(receivedBadges));
  };

  const clearBadges = () => {
    dispatch(clearBadgesAction());
  };

  const setStudentBadges = (receivedStudentBadges: StudentBadgesApiResponse) => {
    dispatch(setStudentBadgesAction(receivedStudentBadges));
  };

  const clearStudentBadges = () => {
    dispatch(clearStudentBadgesAction());
  };

  return {
    badges,
    setBadges,
    clearBadges,
    studentBadges,
    setStudentBadges,
    clearStudentBadges,
  };
};

export default useMenu;
